import { useState } from 'react';
import { Stack, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { appSliceActions } from '../../appSlices/appSlice';
import axiosInstance from '../../utils/axiosInstance';
import fetchDeviceList from '../../utils/fetchDeviceList';
import fetchStreamList from '../../utils/fetchStreamList';
import SingleSelector from '../single-selector/singleSelector';

export default function RemoveCamera() {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [camera, setCamera] = useState(null);
  const cameraList = useSelector((state) => state.app.cameraList);

  const removeCameraApi = () => {
    axiosInstance
      .delete(`${window.location.protocol}//${camera.host}/api/v1/sensor/${camera.sensorId}`)
      .then(async () => {
        enqueueSnackbar(`Success - remove camera ${camera.name}`, {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
        setCamera(null);
        dispatch(appSliceActions.removeDevice(camera));
        const cameraList = await fetchDeviceList(camera.host);
        if (cameraList != null) {
          for (let i = 0; i < cameraList.length; i += 1) {
            cameraList[i].host = camera.host;
          }
          dispatch(appSliceActions.addDevice(cameraList));
        }
        const streamList = await fetchStreamList(camera.host);
        if (streamList != null) {
          for (let i = 0; i < streamList.length; i += 1) {
            streamList[i].host = camera.host;
          }
          dispatch(appSliceActions.addStream(streamList));
        }
      })
      .catch((error) => {
        if (error.response.data == null)
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        else
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
      });
  };

  const handleSubmit = () => {
    enqueueSnackbar(`Pending - remove camera`, {
      variant: 'info',
      anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
    });
    if (!camera) {
      enqueueSnackbar(`Error - Please select camera`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    removeCameraApi();
  };

  return (
    <>
      <Stack spacing={3} sx={{ mb: 2 }}>
        <SingleSelector
          id="remove-cameras"
          placeholder="Type to search"
          label="Select camera"
          value={camera}
          onChange={setCamera}
          getOptionLabel={(option) => {
            if (option.remoteDeviceName && option.remoteDeviceLocation) {
              return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
            } if (option.remoteDeviceName) {
              return `${option.name} at ${option.remoteDeviceName}`;
            }
            return option.name;

          }}
          options={cameraList}
        />
      </Stack>
      <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
        <LoadingButton size="large" type="submit" variant="contained" onClick={handleSubmit}>
          Remove
        </LoadingButton>
      </Box>
    </>
  );
}
